import React from 'react';
import { observer } from 'mobx-react';
import { PropTypes } from 'prop-types';

@observer
export class NewAppUnsavedChangesModal extends React.Component {

	static propTypes = {
		discardChangesAndLeave: PropTypes.func.isRequired,
		modalVisibilities: PropTypes.object.isRequired,
		saveChangesAndLeave: PropTypes.func,
		saveChangesAndLeaveEnabled: PropTypes.bool,
		stayAndKeepEditing:PropTypes.func.isRequired
	};

	onHideModal= () => {
		this.props.stayAndKeepEditing();
	};

	render () {
		if (!this.props.modalVisibilities.unsavedChanges) return null;
		return (
			<div className="modal-wrapper new-app-unsaved-changes-modal">
				<div className="modal fade show" style={{display: 'block'}} role="dialog" aria-modal="true">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<button type="button" className="fn-modal-close" onClick={this.onHideModal}>
								<i aria-hidden="true" className="icon-close"></i>
								<span className="sr-only">Close window</span>
							</button>
							<div className="modal-header text-center">
								<h1 className="as-h2 modal-title">Unsaved Changes</h1>
							</div>
							<div className="modal-body text-center">
								<p>By leaving this page, any unsaved information you entered will be lost. Do you wish to save your changes now?</p>
							</div>
							<div className="row no-gutters modal-actions text-center">
								{this.props.saveChangesAndLeave &&
									<button type="button" disabled={!this.props.saveChangesAndLeaveEnabled} className="fn-primary" onClick={this.props.saveChangesAndLeave}>
										Save &amp; Leave
									</button>
								}
								<button type="button" className={this.props.saveChangesAndLeave ? 'fn-secondary' : 'fn-primary'} onClick={this.props.discardChangesAndLeave}>
									Discard Changes &amp; Leave
								</button>
								<button type="button" className={this.props.saveChangesAndLeave ? 'btn as-link ' : 'fn-secondary'} onClick={this.onHideModal}>
									Stay &amp; Keep Editing
								</button>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-backdrop fade show"></div>
			</div>
		);
	}

}
